"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var next_intl_1 = require("next-intl");
var ui_components_1 = require("@l2p/ui-components");
var swr_hooks_1 = require("@l2p/swr-hooks");
var apps_shared_1 = require("@l2p/apps-shared");
var EmptyHistory = function () {
    var t = (0, next_intl_1.useTranslations)('lottery');
    var isAuth = (0, swr_hooks_1.useIsAuthorized)();
    var openDeposit = (0, apps_shared_1.useOpenDeposit)();
    var openSignUp = (0, apps_shared_1.useOpenSignUp)();
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("img", { className: styles_module_scss_1.default.ticket, src: "/img/lottery/ticket.png", alt: "ticket" }),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.description }, t('noTicketsHistory')),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.buttonWrapper },
            react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", text: "upper", maxWidth: "320px", width: "100%", onClick: function () { return (isAuth ? openDeposit() : openSignUp()); } }, t('depositNow')))));
};
exports.default = EmptyHistory;
